import React, { Component } from 'react';

// Components.
import NotFound from 'components/NotFound';

export default class ErrorPage extends Component {
  constructor() {
    super();

    if(window.location.pathname !== '/404/') {
      window.location.replace('/404/')
    }
  }

  render() {
    return null
    return <NotFound />;
  }

}
